export const ACHIEVEMENT_IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp']);

export function achievementImageFileName(path) {
  return String(path || '').split('/').pop() || '';
}

export function normalizeAchievementImageName(value) {
  return String(value || '')
    .normalize('NFKC')
    .trim()
    .toLocaleLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function createAchievementImageLookup(achievements) {
  const lookup = new Map();
  achievements.forEach(achievement => {
    const key = normalizeAchievementImageName(achievement?.name);
    const values = lookup.get(key) || [];
    values.push(achievement);
    lookup.set(key, values);
  });
  return lookup;
}

export function matchAchievementImageFile(path, lookup) {
  const fileName = achievementImageFileName(path);
  const dotIndex = fileName.lastIndexOf('.');
  if (dotIndex <= 0) return {status: 'ignored', fileName};
  const extension = fileName.slice(dotIndex + 1).toLowerCase();
  if (!ACHIEVEMENT_IMAGE_EXTENSIONS.has(extension)) {
    return {status: 'ignored', fileName, extension};
  }
  const stem = fileName.slice(0, dotIndex);
  const suffixMatch = stem.match(/^(.*?)_(on|off)$/i);
  if (!suffixMatch || !suffixMatch[1].trim()) {
    return {status: 'invalid', fileName, extension};
  }
  const identity = suffixMatch[1].trim();
  const identitySeparator = identity.lastIndexOf('__');
  const achievementName = (identitySeparator > 0 ? identity.slice(0, identitySeparator) : identity).trim();
  const achievementId = identitySeparator > 0 ? identity.slice(identitySeparator + 2).trim() : '';
  const state = suffixMatch[2].toLowerCase() === 'off' ? 'locked' : 'unlocked';
  const candidates = lookup.get(normalizeAchievementImageName(achievementName)) || [];
  if (!candidates.length) {
    return {status: 'unmatched', fileName, extension, achievementName, state};
  }
  const selected = achievementId
    ? candidates.filter(candidate => candidate?.achievement_id === achievementId)
    : candidates;
  if (achievementId && !selected.length) {
    return {status: 'unmatched', fileName, extension, achievementName, achievementId, state};
  }
  if (selected.length > 1) {
    return {status: 'ambiguous', fileName, extension, achievementName, state, candidates};
  }
  const achievement = selected[0];
  return {
    status: 'matched',
    fileName,
    extension,
    achievementName,
    state,
    achievement,
  };
}
